function RefundPolicy() {
  return (
    <>
      <section className="page-header text-center text-white">
        <div className="container">
          <h1 className="fw-bold">Refund & Cancellation Policy</h1>
          <p className="mb-0 opacity-75">Last updated: June 2025</p>
        </div>
      </section>

      <section className="py-5">
        <div className="container policy-content">
          <h4>1. Overview</h4>
          <p>This policy outlines the terms for refunds and cancellations related to course fees and other payments made to Garvit Education.</p>

          <h4>2. Course Fee Refund</h4>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Cancellation Period</th>
                <th>Refund Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Within 7 days of enrollment (before classes begin)</td>
                <td>90% refund (10% administrative charges)</td>
              </tr>
              <tr>
                <td>8–15 days after enrollment (before classes begin)</td>
                <td>70% refund</td>
              </tr>
              <tr>
                <td>After classes have commenced (within first 2 weeks)</td>
                <td>50% refund</td>
              </tr>
              <tr>
                <td>After 2 weeks of classes</td>
                <td>No refund</td>
              </tr>
            </tbody>
          </table>

          <h4>3. Non-Refundable Fees</h4>
          <ul>
            <li>Registration/Application fee</li>
            <li>Examination fees</li>
            <li>Library deposit (refundable only upon course completion)</li>
            <li>Certificate/Convocation fees</li>
          </ul>

          <h4>4. Process for Requesting Refund</h4>
          <ol>
            <li>Submit a written refund request to support@gencollege.in</li>
            <li>Include your full name, enrollment number, course name, and reason for cancellation.</li>
            <li>Refund requests will be processed within 15–30 business days after approval.</li>
            <li>Refunds will be credited to the original payment method.</li>
          </ol>

          <h4>5. Scholarship & Discount Adjustments</h4>
          <p>If a refund is requested after availing a scholarship or discount, the refund amount will be calculated on the discounted fee paid, not the original course fee.</p>

          <h4>6. Course Cancellation by Institute</h4>
          <p>If Garvit Education cancels a course or program for any reason, students will receive a full 100% refund of all fees paid, processed within 15 business days.</p>

          <h4>7. Transfer of Enrollment</h4>
          <p>Students may request to transfer their enrollment to a different course or batch (subject to availability) instead of a refund. Transfer requests must be made within 30 days of original enrollment.</p>

          <h4>8. Contact Us</h4>
          <p>For refund-related queries:</p>
          <p><strong>Email:</strong> support@gencollege.in</p>
        </div>
      </section>
    </>
  );
}

export default RefundPolicy;
